import React from 'react'
import { FormControlLabel } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import 'dayjs/locale/en';
import i18next from 'i18next'
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);

dayjs.updateLocale('vi', {
    months: [
        'Tháng 1',
        'Tháng 2',
        'Tháng 3',
        'Tháng 4',
        'Tháng 5',
        'Tháng 6',
        'Tháng 7',
        'Tháng 8',
        'Tháng 9',
        'Tháng 10',
        'Tháng 11',
        'Tháng 12',
    ],
    monthsShort: [
        'Th1', 'Th2', 'Th3', 'Th4', 'Th5', 'Th6',
        'Th7', 'Th8', 'Th9', 'Th10', 'Th11', 'Th12',
    ],
});

const ItemFormDateTime = ({
    name,
    labelKey,
    rules,
    required = false,
    minDateTime = null,
    maxDateTime = null,
    format = "DD/MM/YYYY HH:mm",
    ...props
}) => {
    const { t } = useTranslation()
    const { control, formState: { errors } } = useFormContext()
    const { labelPlacement = "start" } = props

    const error = get(errors, name)

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { onChange, value, ...field } }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18next.language}>
                    <FormControlLabel
                        label={t(labelKey)}
                        labelPlacement={labelPlacement}
                        control={
                            <DateTimePicker
                                {...field}
                                value={value ? dayjs.unix(value) : null}
                                onChange={(newValue) => {
                                    onChange(newValue ? newValue.unix() : null)
                                }}
                                minDateTime={minDateTime ? dayjs.unix(minDateTime) : undefined}
                                maxDateTime={maxDateTime ? dayjs.unix(maxDateTime) : undefined}
                                format={format}
                                sx={{ flex: 1, width: '100%' }}
                                slotProps={{
                                    textField: {
                                        required: required,
                                        error: !!error,
                                        fullWidth: true,
                                        helperText: error?.message ? t(error.message) : '',
                                        sx: { '& .MuiOutlinedInput-root': { borderColor: '#8F9294' } }
                                    }
                                }}
                                dayOfWeekFormatter={(_day, date) => {
                                    if (i18next.language === 'vi') {
                                        return ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'][date.day()];
                                    }

                                    return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'][date.day()];
                                }}
                                localeText={{
                                    okButtonLabel: i18next.language === 'vi' ? 'Đồng ý' : 'OK',
                                }}
                            />
                        }
                    />
                </LocalizationProvider>
            )}
        />
    )
}

export default ItemFormDateTime
